module.exports = __webpack_public_path__ + "static/img/hg1.a3f5239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hg1.jpg
// module id = QEtd
// module chunks = 1